// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gO","advertCardFooter__row":"c-a_gP","advertCardFooter__name":"c-a_gQ","advertCardFooter__price":"c-a_gR","advertCardFooter__age":"c-a_gS"};